export enum LocalStorageKeys {
   ACCESS_TOKEN = 'ACCESS_TOKEN',
   REFRESH_TOKEN = 'REFRESH_TOKEN',
   EXPIRES_IN = 'EXPIRES_IN',
}

export enum UserRoles {
   MAIN_LOCALIZATION_ADMIN = 'MAIN_LOCALIZATION_ADMIN',
   SUPER_TESTER = 'SUPER_TESTER',
   BASIC = 'BASIC',
   // DEPRECATED
   // TODO: Remove after deploy of new subscriptions
   DEMO = 'DEMO',
   PRO = 'PRO',
   ULTRA = 'ULTRA',
   TESTER = 'TESTER',
   DEMO_SUBSCRIPTION = 'DEMO_SUBSCRIPTION',
   TEST_DRIVE = 'TEST_DRIVE_SUBSCRIPTION',
   SPORT = 'SPORT_SUBSCRIPTION',
   TURBO = 'TURBO_SUBSCRIPTION',
   NITRO = 'NITRO_SUBSCRIPTION',
   REGISTERED_USER = 'REGISTERED_USER',
   SUBSCRIPTION = 'SUBSCRIPTION',
   PZU = 'PZU',
   INTERNAL = 'INTERNAL',
   SALES_REP = 'SALES_REP',
   LOCALIZATION_ADMIN = 'LOCALIZATION_ADMIN',
   DATA_MANAGER = 'DATA_MANAGER',
}

export const DeliveryTypes = ['PICK_UP', 'ADDRESS']

export const PaymentMethods = ['CASH', 'TRANSFER', 'CASH_ON_DELIVERY']

export enum ParametersEnum {
   LOGIN = 'loginParameter',
   PASSWORD = 'passwordParameter',
   ADDITIONAL_PARAMETER = 'additionalParameter',
   SECOND_ADDITIONAL_PARAMETER = 'secondAdditionalParameter',
}

export enum CategoriesEnum {
   TIRES_UUID = '81ccd4e9-b04f-4dcd-b9a0-24ac5a478459',
}

export const MAX_PRODUCT_QUANTITY = 600

export const noInformationsWholesales: { [key: string]: { name: string; url: string } } = {
   '0399a415-1950-4600-9393-c4dea6efbfa8': {
      name: 'inter cars',
      url: 'https://pl.e-cat.intercars.eu/pl',
   },
}
